export default "__VITE_ASSET__DqlkKpJ4__"